import { ExceptionalWorkingDayDateGeneratedEntity } from "./generated/ExceptionalWorkingDayDateGeneratedEntity";

export abstract class ExceptionalWorkingDayDateEntity extends ExceptionalWorkingDayDateGeneratedEntity {
    // Comment to preserve new line
}
